module.exports = __webpack_public_path__ + "img/2.8cdc3f63.jpg";